const countries = require('i18n-iso-countries')

countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
countries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
countries.registerLocale(require('i18n-iso-countries/langs/es.json'))
countries.registerLocale(require('i18n-iso-countries/langs/hu.json'))
countries.registerLocale(require('i18n-iso-countries/langs/de.json'))
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'))
countries.registerLocale(require('i18n-iso-countries/langs/pt.json'))

export function getIsoCountries(language) {
  const obj = countries.getNames(language || 'en')

  return Object.keys(obj).map(key => {
    // The library supports multiple country names, which are given as an array.
    // We really only care about the first name of a country.
    if (Array.isArray(obj[key])) {
      return {
        value: key,
        name: obj[key][0],
      }
    }

    return {
      value: key,
      name: obj[key],
    }
  })
}
